// import "./swiper/v2-multiple/slider";

import Swiper from "./swiper";
// import { sliderV1 } from "./swiper/v1/slider";
// import { sliderV2 } from "./swiper/v2/slider";
// import { sliderV3 } from "./swiper/v3/slider";

// import { sliderV6 } from "./swiper/v6/slider";

import { sliderGalleryV0 } from "./gallery/v0/slider";
import { sliderGalleryV1 } from "./gallery/v1/slider";
// import { sliderGalleryV2 } from "./gallery/v2/slider";
// import { sliderGalleryV3 } from "./gallery/v3/slider";

// import { sliderPtV1 } from "./pt/v1/slider";
// import { sliderHeroV1 } from "./hero/v1/slider";
// import { sliderCustomV1 } from "./custom/v1/slider";
// import { sliderProductsV1 } from "./products/v1/slider";


// import "./gallery/photoswipe";
import { Fancybox } from "@fancyapps/ui";

new Swiper([
  // sliderV1,
  // sliderV2,
  // sliderV3,
  // sliderV6,
  sliderGalleryV0,
  sliderGalleryV1,
  // sliderGalleryV2,
  // sliderGalleryV3,
  // sliderPtV1,
  // sliderHeroV1,
  // sliderCustomV1,
  // sliderProductsV1
]);
